var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleBankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5880_34423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5391 14.3281H27.0391V24.8095H24.5391V14.3281Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 14.3281H20.7891V24.8095H18.2891V14.3281Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7891 14.3281H13.2891V24.8095H10.7891V14.3281Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53906 14.3281H7.03906V24.8095H4.53906V14.3281Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5391 11.9986V10.834H2.03906V11.9986C2.03906 12.6418 2.45793 13.1632 2.97476 13.1632H28.6034C29.1199 13.1632 29.5391 12.6418 29.5391 11.9986Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9101 25.9736H1.66801C1.18253 25.9736 0.789062 26.1971 0.789062 26.4727V27.8037C0.789062 28.0794 1.18253 28.3028 1.66801 28.3028H29.9101C30.3956 28.3028 30.7891 28.0794 30.7891 27.8037V26.4727C30.7891 26.1971 30.3956 25.9736 29.9101 25.9736Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66789 9.66936H29.9101C30.3033 9.66936 30.6487 9.43652 30.7558 9.0992C30.8627 8.76188 30.7057 8.40211 30.3709 8.21845L16.2497 0.468856C15.9673 0.313767 15.6109 0.313767 15.3283 0.468856L1.20715 8.21845C0.872297 8.40231 0.715284 8.76188 0.822401 9.0992C0.929518 9.43652 1.2749 9.66936 1.66789 9.66936ZM13.9138 5.01095H17.6638C18.1492 5.01095 18.2888 5.16043 18.2888 5.59325C18.2888 6.02607 18.1492 6.17555 17.6638 6.17555H13.9138C13.4283 6.17555 13.2888 6.02607 13.2888 5.59325C13.2888 5.16043 13.4283 5.01095 13.9138 5.01095Z",
    fill: "#9C82FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5880_34423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27.9505,
    fill: "white",
    transform: "translate(0.789062 0.352539)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBankIcon);
export default __webpack_public_path__ + "static/media/purple-bank-icon.87742df9f8c919d407285b66e7f875a3.svg";
export { ForwardRef as ReactComponent };